module.exports = __webpack_public_path__ + "static/Profile_AndersOstlund-d7d10ac257c7f2084834d67ec03eb5ae.jpg";